import { RelatedRecipe } from "../model/related_recipe";
import $ from "jquery";

const RELATED_RECIPES_TOOLTIP_TEXT =
  "弊社レシピサービス（cookpad.com）での検索結果のレシピを、人気順（プレミアムサービスでのみ提供される機能）で表示しています。";

// Interface for recipe data
export interface RecipeData {
  id: string;
  name: string;
  image_url?: string;
  url: string; // Made required to match RelatedRecipe's Recipe interface
  tsukurepo_count?: number;
  [key: string]: any;
}

class RelatedRecipesView {
  protected rootElement: JQuery;
  protected recipesBoxElement: JQuery | null = null;

  constructor(rootElement: JQuery) {
    this.rootElement = rootElement;
  }

  initialize(): void {
    const helpIconSrc = String(this.rootElement.data("helpIcon") ?? "");
    const tooltipHtml = `<span class="tooltip"><img src="${helpIconSrc}" alt="" /><span class="description">${RELATED_RECIPES_TOOLTIP_TEXT}</span></span>`;
    const headerElement = `
      <div class="related_recipes_box_vert f_right">
        <h3 class="related_recipes_heading">関連レシピ${tooltipHtml}</h3>
        <div class="recipes_box">
          <div class="indicator gr" />
        </div>
      </div>
    `;
    this.rootElement.append(headerElement);
    this.recipesBoxElement = this.rootElement.find(".recipes_box");
  }

  renderRelatedRecipes(recipes: RecipeData[]): void {
    this.removeIndicator();

    if (recipes.length > 0) {
      recipes.forEach((recipeData, index) => {
        const recipe = new RelatedRecipe(
          recipeData,
          this.blankLogoSrc(),
          index + 1,
        );
        this.recipesBoxElement!.append(recipe.toHtml());
      });
    } else {
      this.showNotFoundMessage();
    }
  }

  protected removeIndicator(): void {
    if (this.recipesBoxElement) {
      this.recipesBoxElement.empty();
    }
  }

  protected blankLogoSrc(): string {
    return this.rootElement.data("blank-logo") || "";
  }

  protected showNotFoundMessage(): void {
    this.removeIndicator();
    this.renderMessage("見付かりませんでした");
  }

  protected renderMessage(message: string): void {
    const escapedMessage = $("<div>").text(message).html();
    this.recipesBoxElement!.append(`<p>${escapedMessage}</p>`);
  }

  renderErrorMessage(message: string): void {
    this.removeIndicator();
    const escapedMessage = $("<div>").text(message).html();
    this.recipesBoxElement!.append(`<p class="error">${escapedMessage}</p>`);
  }
}

export { RelatedRecipesView };
